module.exports = __webpack_public_path__ + "img/header-slide-1-720@2x.6b7468c8.png";